module.exports = __webpack_public_path__ + "img/section13.2416b8f5.png";